import { Context } from '@alltrails/shared/types/context';
import usePathname from 'hooks/usePathname';
import { Page } from 'components/shared/Page/Page';
import Router from '@alltrails/shared/components/ReactRouter';
import WelcomeHeader from 'components/welcome/WelcomeHeader';
import ProComparison from 'components/welcome/ProComparison';
import PlusFeatureCarousel from 'components/welcome/PlusFeatureCarousel';
import OnePercentBlock from 'components/blocks/OnePercentBlock';
import AppDownloadAndReview from 'components/welcome/AppDownloadAndReview';
import * as styles from './styles.module.scss';

type WelcomeProps = {
  context: Context;
};

const Welcome = ({ context }: WelcomeProps): JSX.Element => {
  const fullpath = usePathname();

  return (
    <div>
      <Page context={context}>
        <Router fullpath={fullpath}>
          <div className={styles.innerContainer}>
            <WelcomeHeader />
            <PlusFeatureCarousel />
            <ProComparison />
            <AppDownloadAndReview />
          </div>
          <OnePercentBlock />
        </Router>
      </Page>
    </div>
  );
};

export default Welcome;
